interface ValueWithExpiry<T> {
  expiry: number;
  data: T;
}

// This doesn't implement proper expiries and only evicts keys when read. It's meant to solve the problem of
// stale data in the cache not memory issues. If there are memory issues we could enhance this to use a LRU cache
// or schedule deletions.
export class CacheWithExpiry<K, V> {
  private cache: Map<K, ValueWithExpiry<V>>;
  private expiryMs: number;

  constructor(expiryMs: number) {
    this.cache = new Map<K, ValueWithExpiry<V>>();

    if (expiryMs <= 0) {
      throw new Error('Expiry must be greater than 0');
    }

    this.expiryMs = expiryMs;
  }

  get(key: K) {
    const cachedItem = this.cache.get(key);

    if (!cachedItem) {
      return undefined;
    }

    const { expiry, data } = cachedItem;

    if (expiry < Date.now()) {
      this.delete(key);

      return undefined;
    }

    return data;
  }

  set(key: K, value: V) {
    const expiry = Date.now() + this.expiryMs;

    this.cache.set(key, { expiry, data: value });
  }

  delete(key: K) {
    this.cache.delete(key);
  }

  clear() {
    this.cache.clear();
  }
}
